import React from "react";
import { useRef, useEffect, useState } from "react";
import "./OnlineBooking.css"
import {
  UpdateSiteContactDetails,
  UpdateConfigAddress,
  UpdateWebsiteLink
} from './Requests';
import {PulseLoader } from "react-spinners";
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess
} from '../Response/ResposeHandler'
import { PresentToAllSharp } from "@mui/icons-material";

const Details = (props) => {
    const [addressNameNumber, setAddressNameNumber] = useState(props.config.addressNumberName)
    const [addressFirstLine, setAddressFirstLine] = useState(props.config.addressFirstLine)
    const [addressSecondLine, setAddressSecondLine] = useState(props.config.addressSecondLine)
    const [addressCity, setAddressCity] = useState(props.config.addressCity)
    const [addressCounty, setAddressCounty] = useState(props.config.addressCounty)
    const [addressPostcode, setAddressPostcode] = useState(props.config.addressPostcode)
    let errorsInfoObj = { NameNumber: '', firstLine: '', secondLine: '', city: '', county: '', mobile: '', postcode:'' };
    const [infoErrors, setInfoErrors] = useState(errorsInfoObj);
    const [contactButtonLoading, setContactButtonLoading] = useState(false)
    const [websiteButtonLoading, setWebsiteButtonLoading] = useState(false)
    const [website, setWebsite] = useState(props.config.websiteLink)
    const [phoneNumber, setPhoneNumber] = useState(props.config.phoneNumberForCustomer)
    const [emailAddress, setEmailAddress] = useState(props.config.emailForCustomer)


      //   function SubmitContactDetails() {
      //     let error = false;
      //     const errorInfoObj = { ...errorsInfoObj };
    
      //     if ((!addressNameNumber && !addressFirstLine && !addressSecondLine && !addressCity && !addressCounty && !addressPostcode))
      //     {
    
      //     }
      //     else{
    
      //       if ((!addressNameNumber && !addressFirstLine && !addressSecondLine && !addressCity && !addressCounty && !addressPostcode))
      //       {
    
      //       }
      //       else{
    
          
      //       if (!addressNameNumber)
      //         {
      //           errorInfoObj.NameNumber = "Address name or number cannot be empty"
      //           error = true
      //         }
      //       if (!addressFirstLine)
      //         {
      //           errorInfoObj.firstLine = "First line of address cannot be empty"
      //           error = true
      //         }
      //       if (!addressCity)
      //         {
      //           errorInfoObj.city = "Please enter a city or town"
      //           error = true
      //         }
      //       if (!addressPostcode)
      //         {
      //           errorInfoObj.postcode = "Postcode cannot be empty"
      //           error = true
      //         }
      //       }
      //     }
      //     if (error)
      //     {
      //       notifyError("Please check you have filled out the contact details correctly")
      //     }
    
      //   setInfoErrors(errorInfoObj)
      //   if (error === false) {
      //       setContactButtonLoading(true)
      //       UpdateConfigAddress(addressNameNumber, addressFirstLine, addressSecondLine, addressCity, addressCounty, addressPostcode).then((res) => {
      //         notifySuccess("Contact Details Saved")
      //       }).catch((error) => {
      //         notifyError("Something went wrong, please try again or contact support")
      //       }).finally(()=> {
      //         props.getConfig()
      //         setContactButtonLoading(false)
      //       })
    
      //   }
      // }

          function SubmitContactDetails() {
            let error = false;
            const errorInfoObj = { ...errorsInfoObj };
      
            if ((!addressNameNumber && !addressFirstLine && !addressSecondLine && !addressCity && !addressCounty && !addressPostcode && !phoneNumber && !emailAddress))
            {
      
            }
            else{
      
              if ((!addressNameNumber && !addressFirstLine && !addressSecondLine && !addressCity && !addressCounty && !addressPostcode) && (phoneNumber || emailAddress))
              {
      
              }
              else{
      
            
              if (!addressNameNumber)
                {
                  errorInfoObj.NameNumber = "Address name or number cannot be empty"
                  error = true
                }
              if (!addressFirstLine)
                {
                  errorInfoObj.firstLine = "First line of address cannot be empty"
                  error = true
                }
              if (!addressCity)
                {
                  errorInfoObj.city = "Please enter a city or town"
                  error = true
                }
              if (!addressPostcode)
                {
                  errorInfoObj.postcode = "Postcode cannot be empty"
                  error = true
                }
              }
            }
            if (error)
            {
              notifyError("Please check you have filled out the contact details correctly")
            }
      
          setInfoErrors(errorInfoObj)
          if (error === false) {
              setContactButtonLoading(true)
              UpdateSiteContactDetails(addressNameNumber, addressFirstLine, addressSecondLine, addressCity, addressCounty, addressPostcode, phoneNumber, emailAddress).then((res) => {
                notifySuccess("Contact Details Saved")
              }).catch((error) => {
                notifyError("Something went wrong, please try again or contact support")
              }).finally(()=> {
                // props.getSite()
                setContactButtonLoading(false)
              })
      
          }
        }

      function SubmitWebsite() {
        console.log(website)
    UpdateWebsiteLink(website).then((res) => {
      if (res.status === 200)
      {
        notifySuccess("Website Saved")
      }
    }).catch((e) => {
      notifyError("There was an issue saving the website, please try again or contact support")
    }).finally((f) => {
      props.getConfig()
    })
      }

   return (
    <div>
      {/* <ToastContainer/> */}
      <label style={{marginTop:"2rem"}} htmlFor="website-link">Website Link<span style={{fontSize:"0.8rem"}}>(start the website link with https:// or http://)</span></label>
      <input maxLength={40} value={website} required onChange={(e) => {setWebsite(e.target.value)}} type="text" id="website-link" placeholder="website link"/>

        <button disabled={websiteButtonLoading} onClick={() => {SubmitWebsite()}} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
        {!websiteButtonLoading ?
        "Save Website":
        <PulseLoader 
          color={'#eee'}
          loading={websiteButtonLoading}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        }
      </button>

      {/* <h3 style={{marginTop:"7rem"}}>Address Details</h3>
      <p>This address will be used in the footer of your site as well as being included on your emails to your clients</p>
      <label style={{marginTop:0}} htmlFor="address-number-name">Number or Name</label>
      <input value={addressNameNumber} onChange={(e) => {setAddressNameNumber(e.target.value)}} type="text" id="address-number-name" placeholder="Number / Name"/>
      {infoErrors.NameNumber && <div className="text-danger fs-12">{infoErrors.NameNumber}</div>}
      
      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-first-line">First Line</label>
      <input value={addressFirstLine} onChange={(e) => {setAddressFirstLine(e.target.value)}} type="text" id="address-first-line" placeholder="First Line"/>
      {infoErrors.firstLine && <div className="text-danger fs-12">{infoErrors.firstLine}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-second-line">Second Line</label>
      <input value={addressSecondLine} onChange={(e) => {setAddressSecondLine(e.target.value)}} type="text" id="address-second-line" placeholder="Second Line"/>
      {infoErrors.secondLine && <div className="text-danger fs-12">{infoErrors.secondLine}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-city">City</label>
      <input value={addressCity} onChange={(e) => {setAddressCity(e.target.value)}} type="text" id="address-city" placeholder="City"/>
      {infoErrors.city && <div className="text-danger fs-12">{infoErrors.city}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-county">County</label>
      <input value={addressCounty} onChange={(e) => {setAddressCounty(e.target.value)}} type="text" id="address-county" placeholder="County"/>
      {infoErrors.county && <div className="text-danger fs-12">{infoErrors.county}</div>}

      <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-postcode">Postcode</label>
      <input value={addressPostcode} onChange={(e) => {setAddressPostcode(e.target.value)}} type="text" id="address-postcode" placeholder="Postcode"/>
      {infoErrors.postcode && <div className="text-danger fs-12">{infoErrors.postcode}</div>}

      <button disabled={contactButtonLoading} onClick={() => {SubmitContactDetails()}} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
                {!contactButtonLoading ?
        "Save Contact Details":
        <PulseLoader 
          color={'#eee'}
          loading={contactButtonLoading}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        }
      </button> */}

            <h3 style={{marginTop:"7rem"}}>Contact Details</h3>
            <p>This address will be used in the footer of your site as well as being included on your emails to your clients</p>
            <label style={{marginTop:0}} htmlFor="address-number-name">Number or Name</label>
            <input maxLength={45} value={addressNameNumber} onChange={(e) => {setAddressNameNumber(e.target.value)}} type="text" id="address-number-name" placeholder="Number / Name"/>
            {infoErrors.NameNumber && <div className="text-danger fs-12">{infoErrors.NameNumber}</div>}
            
            <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-first-line">First Line</label>
            <input maxLength={45} value={addressFirstLine} onChange={(e) => {setAddressFirstLine(e.target.value)}} type="text" id="address-first-line" placeholder="First Line"/>
            {infoErrors.firstLine && <div className="text-danger fs-12">{infoErrors.firstLine}</div>}
      
            <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-second-line">Second Line</label>
            <input maxLength={45} value={addressSecondLine} onChange={(e) => {setAddressSecondLine(e.target.value)}} type="text" id="address-second-line" placeholder="Second Line"/>
            {infoErrors.secondLine && <div className="text-danger fs-12">{infoErrors.secondLine}</div>}
      
            <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-city">City</label>
            <input maxLength={45} value={addressCity} onChange={(e) => {setAddressCity(e.target.value)}} type="text" id="address-city" placeholder="City"/>
            {infoErrors.city && <div className="text-danger fs-12">{infoErrors.city}</div>}
      
            <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-county">County</label>
            <input maxLength={45} value={addressCounty} onChange={(e) => {setAddressCounty(e.target.value)}} type="text" id="address-county" placeholder="County"/>
            {infoErrors.county && <div className="text-danger fs-12">{infoErrors.county}</div>}
      
            <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="address-postcode">Postcode</label>
            <input value={addressPostcode} onChange={(e) => {setAddressPostcode(e.target.value)}} type="text" id="address-postcode" placeholder="Postcode"/>
            {infoErrors.postcode && <div className="text-danger fs-12">{infoErrors.postcode}</div>}
      
            <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="phone-number">Email Address <span style={{fontSize:"0.8rem"}}>(use am email that you want your clients to contact you on)</span></label>
            <input maxLength={45} value={emailAddress} onChange={(e) => {setEmailAddress(e.target.value)}} type="email" id="email" placeholder="Email"/>
      
            <label style={{marginTop:0, marginTop:"1rem"}} htmlFor="phone-number">Phone Number <span style={{fontSize:"0.8rem"}}>(use a mobile that you want your clients to contact you on)</span></label>
            <input maxLength={12} value={phoneNumber} onChange={(e) => {setPhoneNumber(e.target.value)}} type="tel" id="tel" placeholder="Phone Number"/>
            {infoErrors.mobile && <div className="text-danger fs-12">{infoErrors.mobile}</div>}
      
            <button disabled={contactButtonLoading} onClick={SubmitContactDetails} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
                      {!contactButtonLoading ?
              "Save Contact Details":
              <PulseLoader 
                color={'#eee'}
                loading={contactButtonLoading}
                size={10}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
              }
            </button>


    </div>
   );
};

export default Details;
